module.exports = __webpack_public_path__ + "img/shein.29e1e76b.jpg";